import React from 'react'
import BreakingNews from './BreakingNews'
import QuizAnswer from './QuizAnswer'

const QuizQuestion = (props) => {

  const {
    answeredCorrectly,
    questionAnswer,
    moved,
    submitPart2,
    setAnsweredCorrectlyStep2,
    answeredCorrectlyStep2,
    selectedOption,
    setSelectedOption
  } = props

  if (answeredCorrectly === null || submitPart2 === 1)
    return (
      <BreakingNews
        questionAnswer={questionAnswer}
        submitPart2={submitPart2}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
    )

  return (
    <QuizAnswer
      questionAnswer={questionAnswer}
      moved={moved}
      setAnsweredCorrectlyStep2={setAnsweredCorrectlyStep2}
      answeredCorrectlyStep2={answeredCorrectlyStep2}
      submitPart2={submitPart2}
      selectedOption={selectedOption}
      showBriefness={answeredCorrectly ? false : true}
    />
  )
}

export default QuizQuestion
